<template>
    <span class="text-xs font-bold uppercase">
        <span :style="{ color: 'var(--color-sentiment-negative)' }">H</span>
        <span :style="{ color: 'var(--color-sentiment-negative-to-neutral)' }">e</span>
        <span :style="{ color: 'var(--color-sentiment-neutral-to-negative)' }">a</span>
        <span :style="{ color: 'var(--color-sentiment-neutral)' }">t</span>
        <span :style="{ color: 'var(--color-sentiment-neutral-to-positive)' }">m</span>
        <span :style="{ color: 'var(--color-sentiment-positive-to-neutral)' }">a</span>
        <span :style="{ color: 'var(--color-sentiment-positive)' }">p</span>
    </span>
</template>
